module.exports = __webpack_public_path__ + "static/media/2.6e3a7184.jpg";